import React, { useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  updateSubDommainFrameWork,
  addSubDomainFrameWork,
} from "../../../../actions/MasterDataActions/FrameworkAction";

function FrameworkSubDomainForm(props) {
  const { updateData, fdomain, isCreate, handleClose } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    //console.log(".....currentDomain", fdomain, isCreate);
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    if (isCreate) {
      // console.log(".....updateData", updateData, fdomain, isCreate);
      dispatch(
        addSubDomainFrameWork({
          name: data.name,
          index: parseInt(data?.index),
          frameworkDomainSlug: fdomain?.slug,
          status: data.status,
        })
      );
    } else {
      // if (data.name !== updateData.name) {
      dispatch(
        updateSubDommainFrameWork({
          name: data?.name,
          index: parseInt(data?.index),
          frameworkSubdomainSlug: updateData?.slug,
          frameworkDomainSlug: sessionStorage.getItem("fdomain"), //fdomain?.slug,
          status: data?.status,
        })
      );
      // }
    }
    handleClose();
  };
  return (
    <div>
      <Container>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm="3" className="font-semi-bold-TKL">
              Danielson Framework Component{" "}
              <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="9">
              <Form.Control
                name="name"
                type="text"
                defaultValue={updateData.name ? updateData.name : ""}
                placeholder="Enter Name"
                className="rounded-pill"
                size="sm"
                {...register("name", { required: true })}
              />

              {errors.name && (
                <p className="show-txt-error p-2 m-2">
                  Danielson Framework Component is Required
                </p>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="name">
            <Form.Label column sm="3" className="font-semi-bold-TKL">
              Index Number <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="9">
              <Form.Control
                name="name"
                type="number"
                min="0"
                defaultValue={updateData.index ? updateData.index : 0}
                placeholder="Enter Index Number"
                className="rounded-pill"
                size="sm"
                {...register("index", { required: true })}
              />

              {errors.index && (
                <p className="show-txt-error p-2 m-2">
                  Serial Number is Required
                </p>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="status">
            <Form.Label column sm="3" className="font-semi-bold-TKL">
              Status
            </Form.Label>
            <Col sm="9" className="select-container">
              <span className="select-arrow-icon material-icons">
                expand_more
              </span>

              <Form.Control
                {...register("status", { required: true })}
                as="select"
                className="rounded-pill select-styles"
                size="sm"
                defaultValue={
                  updateData?.status ? updateData?.status : "INACTIVE"
                }
              >
                <option name="INACTIVE">INACTIVE</option>
                <option name="ACTIVE">ACTIVE</option>
              </Form.Control>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="buttonss">
            <Row className="mt-3 mr-2 ml-auto mr-3s">
              <Button
                className="m-2 btn btn-secondary rounded-pill"
                onClick={handleClose}
              >
                Close
              </Button>
              <Button
                type="submit"
                className="m-2 btn btn-primary rounded-pill"
              >
                {isCreate ? "Create" : "Update"}
              </Button>
            </Row>
          </Form.Group>
        </form>
      </Container>
    </div>
  );
}

export default FrameworkSubDomainForm;
